export const CONTAINER_HEIGHT = 400;
export const CLIPPER_MIN_WIDTH = 320;

export const VideoEditor = {
  Clipper: 'Clipper',
  Cropper: 'Cropper',
  Thumbnail: 'Thumbnail',
};
